export var HiddenLabelIdGenerator = function (hiddenLabel) {
    return hiddenLabel !== ''
        ? "hiddenLabel-" + hiddenLabel.replace(/\s/g, '').slice(-4)
        : null;
};
//# sourceMappingURL=HiddenLabelIdGenerator.js.map